import { render, staticRenderFns } from "./appealDetails.vue?vue&type=template&id=69c75fe4&scoped=true"
import script from "./appealDetails.vue?vue&type=script&lang=js"
export * from "./appealDetails.vue?vue&type=script&lang=js"
import style0 from "./appealDetails.vue?vue&type=style&index=0&id=69c75fe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c75fe4",
  null
  
)

export default component.exports